<template>
  <el-dialog class="create-rust-detector-task-dialog common-dialog" title="创建任务" :visible.sync="showDialog" top="25vh" @open="onShow">
    <el-form ref="createTask" :model="model" :rules="rules" :label-width="`${adaptationVars.formLabelWidth}px`">
      <el-form-item label="待检测合约" prop="contract">
        <el-select v-model="model.contract" placeholder="请选择合约">
          <el-option v-for="(item, index) in contractOptions" :key="index" :label="item.Filename"
            :value="item.ID"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="待检测函数" prop="functions">
        <dynamic-tags v-model="model.functions" btn-str="+ 新建函数名"></dynamic-tags>
      </el-form-item>
      <el-form-item label="指令数量统计" prop="countInstruction">
        <el-switch v-model="model.countInstruction"></el-switch>
      </el-form-item>
      <el-form-item label="Wast格式检测" prop="wast">
        <el-switch v-model="model.wast"></el-switch>
      </el-form-item>
      <el-form-item label="Wasm格式检测" prop="wasm">
        <el-switch v-model="model.wasm"></el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import dynamicTags from './components/dynamicTags'
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateRustDetectorTask',
  components: {
    dynamicTags
  },
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 160
  },
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
      model: {
        contract: '',
        functions: [],
        countInstruction: false,
        wast: false,
        wasm: false
      },
      rules: {
        contract: [{ required: true, message: '请选择合约', trigger: 'blur' }],
        functions: [
          {
            type: 'array',
            required: false,
            min: 0,
            message: '请输入待检测函数',
            trigger: 'blur'
          }
        ]
      },
      contractOptions: [],
      showDialog: false,
      adaptationVars: {
        formLabelWidth: 160
      }
    }
  },
  watch: {
    dialogVisible: function (val) {
      this.showDialog = val
    },
    showDialog: function (val) {
      this.$emit('update:dialogVisible', val)
    },
    model: {
      handler(val, oldval) {
        // console.log(val)
      },
      deep: true
    }
  },
  mounted() { },
  methods: {
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$refs['createTask'].validate(valid => {
        if (valid) {
          console.log('submit!')

          self.$apis.contractdetector
            .addRustDetectTask({
              ContractID: self.model.contract,
              Functions: self.model.functions,
              CountInstruction: self.model.countInstruction,
              Wast: self.model.wast,
              Wasm: self.model.wasm
            })
            .then(res => {
              if (res && res.data && res.code === 1) {
                self.showDialog = false

                self.$emit('createSuccess')
                self.$message({
                  type: 'success',
                  message: '创建任务成功!'
                })
              } else {
                if (!res.error) {
                  self.$message({
                    type: 'error',
                    message: '创建任务失败!'
                  })
                } else {
                  const h = self.$createElement
                  self.$message({
                    type: 'error',
                    message: h('p', null, [
                      h('div', { style: 'color: red' }, '创建任务失败!'),
                      h('div', { style: 'color: teal' }, res.error)
                    ])
                  })
                }
              }
              // console.log(res)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onShow() {
      this.getContracts()
    },
    getContracts() {
      let self = this
      new Promise(async (resolve, reject) => {
        try {
          let contractOptions = []
          let res = await self.$apis.contractdetector.getRustContractList({
            offset: 0,
            limit: 20
          })
          if (res && res.data && res.code === 1) {
            contractOptions.push.apply(contractOptions, res.data.items)
            for (let i = 20; i < res.data.total; i += 20) {
              res = await self.$apis.contractdetector.getRustContractList({ offset: i, limit: 20 })
              contractOptions.push.apply(contractOptions, res.data.items)
            }
          }
          resolve(contractOptions)
        } catch (e) {
          console.log(e)
        }
      }).then(data => {
        // console.log('获取合约列表成功', data)
        self.contractOptions = data
        if (data.length > 0) {
          self.model.contract = data[0].ID
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.create-rust-detector-task-dialog {

  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--base-size-48);
  }

  .el-select {
    width: 100%;
  }
}
</style>
